// import { useTranslation } from 'next-i18next'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

import { URL_FACEBOOK, URL_INSTAGRAM } from '@goodfellas/environment'

import FooterMenu from './FooterMenu'
import Newsletter from './Newsletter'
import { FacebookIcon, InstagramIcon, LinkedInIcon } from './icons'

const URL_LINKEDIN =
  'https://www.linkedin.com/company/90361628/admin/feed/posts/'

// Define the props for the Header component
type FooterProps = {
  slug: string
}

export const Footer = ({ slug }: FooterProps) => {
  const isAvaliacao = slug.startsWith('/avaliacao')
  const { t } = useTranslation('common')

  return (
    <footer
      className={`${!isAvaliacao ? 'bg-black p-5' : 'bg-transparent p-0'}`}
      id="footer"
    >
      <div className="container text-white/85 pb-5 text-left" id="footer-info">
        {!isAvaliacao && (
          <>
            <div className="row">
              <Image
                src="/images/logos/goodfellas-icon-secondary.svg"
                alt="Goodfellas"
                className="w-auto mb-4 ms-0 max-w-32"
                width={110}
                height={110}
              />
            </div>
            <div className="row">
              <div className="w-full lg:w-7/12 pe-5">
                <p className="text-lg">{t('footer.manifesto')}</p>
                <FooterMenu />
              </div>

              <Newsletter />
            </div>
          </>
        )}

        <div
          className={`text-center text-[13px] pb-0 text-white/70 ${
            !isAvaliacao
              ? 'mt-5 p-5 border-t border-t-white/10'
              : 'mt-2 p-0 border-0'
          }`}
        >
          <div className={`flex flex-row justify-center gap-4 mb-3`}>
            <Link href={URL_FACEBOOK} aria-label="Facebook" target="_blank">
              <FacebookIcon />
            </Link>
            <Link href={URL_INSTAGRAM} aria-label="Instagram" target="_blank">
              <InstagramIcon />
            </Link>
            <Link href={URL_LINKEDIN} aria-label="LinkedIn" target="_blank">
              <LinkedInIcon />
            </Link>
          </div>
          <p className={`pb-2`}>
            <a href="tel:+551150287668" className="hover:text-white">
              +55 11 5028-7668
            </a>
            <span className="mx-2">·</span>
            <Link href="/termos" className="hover:text-white">
              Termos de Serviço
            </Link>
            <span className="mx-2">·</span>
            <Link href="/privacidade" className="hover:text-white">
              Política de Privacidade
            </Link>
          </p>
          <p className={`pb-1`}>
            Copyright &#169; 2025 - Goodfellas Ciências das Artes Marciais Ltda.
          </p>
        </div>
      </div>
    </footer>
  )
}
